import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';
import { UserProvider } from '../../providers/user/user';
import { LoginProvider } from './login.provider';

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
  ],
  providers: [
    LoginProvider,
    UserProvider
  ]
})
export class LoginPageModule { }



// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts